import { UploadCloud, X } from 'lucide-react'
import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { productImageUrl } from '../lib/images'

export function AdminImageUpload({ value, onChange, folder = 'content', label = 'Imagem' }: { value: string | null; onChange: (path: string | null) => void; folder?: string; label?: string }) {
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')

  const upload = async (file: File) => {
    setUploading(true); setError('')
    try {
      const mimeTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/avif']
      if (!mimeTypes.includes(file.type)) throw new Error('Use JPG, PNG, WebP ou AVIF.')
      if (file.size > 12 * 1024 * 1024) throw new Error('Imagem muito grande. O limite é 12 MB.')
      const ext = file.name.split('.').pop()?.toLowerCase() || 'jpg'
      const path = `${folder}/${crypto.randomUUID()}.${ext}`
      const { error: uploadError } = await supabase.storage.from('product-images').upload(path, file, { upsert: false, cacheControl: '3600' })
      if (uploadError) throw uploadError
      onChange(path)
    } catch (err) { setError(err instanceof Error ? err.message : 'Falha no upload.') }
    finally { setUploading(false) }
  }

  return (
    <div className="admin-upload">
      <label>{label}</label>
      {value && <div className="admin-upload__preview"><img src={productImageUrl(value)} alt={label} /><button type="button" aria-label="Remover imagem" onClick={() => onChange(null)}><X size={16} /></button></div>}
      <label className="admin-upload__drop">
        <UploadCloud />
        <span>{uploading ? 'Enviando...' : value ? 'Trocar imagem' : 'Selecionar imagem'}</span>
        <input type="file" accept="image/jpeg,image/png,image/webp,image/avif" disabled={uploading}
          onChange={e => { const file = e.target.files?.[0]; if (file) void upload(file); e.target.value = '' }} />
      </label>
      {error && <small className="form-error">{error}</small>}
    </div>
  )
}
